import { render, staticRenderFns } from "./ArticalCard.vue?vue&type=template&id=1b02140e&scoped=true&"
import script from "./ArticalCard.vue?vue&type=script&lang=ts&"
export * from "./ArticalCard.vue?vue&type=script&lang=ts&"
import style0 from "./ArticalCard.vue?vue&type=style&index=0&id=1b02140e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b02140e",
  null
  
)

export default component.exports